import React from 'react';
import logo from './logo.svg';
import './App.css';
import Vdp from './Vdp.js'
import jexcelStyle from 'jexcel/dist/jexcel.css';


function App() {
  return (
    <div className="VDPApp">
    	<div className="VDPApp__inner">
      		<Vdp/>
    	</div>
    </div>
  );
}

export default App;




